import { combineReducers, } from '@reduxjs/toolkit';
import { fromEntries } from '../utils/utils.js';
export function createReducerManager(initialReducers, preloadedState) {
    const reducers = { ...initialReducers };
    let crossReducer;
    const rootReducer = (combined) => {
        return (state, action) => {
            const intermediate = combined(state, action);
            const final = crossReducer
                ? crossReducer(intermediate, action)
                : intermediate;
            return final;
        };
    };
    return {
        get combinedReducer() {
            const placeholderReducers = fromEntries(Object.entries(preloadedState)
                .filter(([key]) => !(key in reducers))
                .map(([key, value]) => [key, (() => value)]));
            return rootReducer(combineReducers({ ...placeholderReducers, ...reducers }));
        },
        containsAll(newReducers) {
            const keys = Object.keys(newReducers);
            return keys.every((key) => key in reducers);
        },
        add(newReducers) {
            Object.keys(newReducers)
                .filter((key) => !(key in reducers))
                .forEach((key) => (reducers[key] = newReducers[key]));
        },
        addCrossReducer(reducer) {
            crossReducer = reducer;
        },
    };
}
